<div
  class="relative inline-flex items-center rounded-full bg-shikenso-purple-base-10 p-1"
  role="group"
  [attr.aria-busy]="loading()"
>
  <span
    #thumb
    aria-hidden="true"
    class="absolute top-1 bottom-1 left-0 rounded-full bg-shikenso-base-white opacity-0 shadow-[0_1px_4px_rgba(31,2,36,0.12)] transition-[transform,width] ease-out will-change-transform motion-reduce:transition-none"
    [style.transition-duration.ms]="thumbSlideMs"
  ></span>

  @for (option of options(); track option.value) {
    <button
      #segment
      type="button"
      class="relative flex h-8 items-center gap-2 rounded-full px-4 text-sm text-shikenso-purple-base"
      [class.invisible]="loading()"
      [attr.aria-pressed]="option.value === selectedValue()"
      (click)="select(option.value)"
    >
      @if (option.icon) {
        <app-icon alt="" [src]="option.icon" [size]="16" />
      }
      <span>{{ option.label | translate }}</span>
      @if (option.count !== undefined && option.count !== null) {
        <span class="text-shikenso-purple-base-60">{{ option.count }}</span>
      }
    </button>
  }

  @if (loading()) {
    <ngx-skeleton-loader
      class="absolute inset-0 flex"
      [theme]="{ height: '100%', width: '100%', margin: '0', 'border-radius': '100vw' }"
    />
  }
</div>
